import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default function CustomerConflictModal({
  conflictModal, conflictChoices, setConflictChoices,
  onCancel, onSubmit,
}) {
  if (!conflictModal) return null;
  return (
    <Dialog open={true} onOpenChange={(v) => { if (!v) onCancel(); }}>
      <DialogContent className="max-w-md" data-testid="customer-conflict-modal">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-amber-600" />
            Update customer record?
          </DialogTitle>
          <p className="text-xs text-slate-500 mt-1">
            <span className="font-semibold">{conflictModal.customer.name}</span> ({conflictModal.customer.phone_e164}) already has different values for these fields. Choose <em>Update</em> to overwrite the customer record or <em>Keep current</em> to leave it untouched. The ticket will be created either way.
          </p>
        </DialogHeader>
        <div className="space-y-3 max-h-72 overflow-y-auto">
          {conflictModal.conflicts.map((c) => (
            <div key={c.field} className="border border-slate-200 rounded-lg p-3"
                 data-testid={`conflict-row-${c.field}`}>
              <div className="text-[10px] uppercase tracking-wider text-slate-500 font-bold mb-1">
                {c.field}
              </div>
              <div className="grid grid-cols-2 gap-2">
                <button type="button"
                        onClick={() => setConflictChoices((s) => ({ ...s, [c.field]: "keep" }))}
                        data-testid={`conflict-${c.field}-keep`}
                        className={`text-left p-2 rounded border text-xs ${conflictChoices[c.field] === "keep" ? "bg-slate-100 border-slate-400" : "border-slate-200 hover:bg-slate-50"}`}>
                  <div className="text-[9px] text-slate-500 mb-0.5">Keep current</div>
                  <div className="text-slate-800 break-words">{c.from}</div>
                </button>
                <button type="button"
                        onClick={() => setConflictChoices((s) => ({ ...s, [c.field]: "update" }))}
                        data-testid={`conflict-${c.field}-update`}
                        className={`text-left p-2 rounded border text-xs ${conflictChoices[c.field] === "update" ? "bg-indigo-50 border-indigo-400" : "border-slate-200 hover:bg-slate-50"}`}>
                  <div className="text-[9px] text-indigo-600 mb-0.5">Update to</div>
                  <div className="text-slate-800 break-words">{c.to}</div>
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2 pt-3 border-t border-slate-100">
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onSubmit}
                  className="bg-indigo-600 hover:bg-indigo-700"
                  data-testid="conflict-submit-btn">
            Save ticket
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
